module.exports = __webpack_public_path__ + "static/media/loginImage.2f21b2f9.png";